import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /community-hub — the old "all spaces" list is gone: programs live on
 * /programs and communities in the sidebar's Community menu. Kept as a route
 * only so old links and bookmarks land somewhere useful.
 */
export const Route = createFileRoute('/_protected/community-hub/')({
  beforeLoad: () => {
    throw redirect({ to: '/programs', replace: true });
  },
});
